// Angular Files
import { inject, Injectable } from '@angular/core';

// Other External Files
import { firstValueFrom } from 'rxjs';

// Teller Online Files
import {
    ConfigurationApiClient,
    SaveTerminologyRequestDto,
    TerminologyConfigDto,
    TerminologyOverrideDto
} from 'apps/admin-portal/src/app/core/api/AdminPortalApiClients';

// Teller Online Library Files
import { RumEvent, TellerOnlineRumService } from 'teller-online-libraries/core';

@Injectable({
    providedIn: 'root'
})
export class TerminologyService {
    private readonly _client = inject(ConfigurationApiClient);

    private readonly _rum = inject(TellerOnlineRumService);

    public async getTerminology(publicPortalSiteId: number): Promise<TerminologyConfigDto[]> {
        const terms = await firstValueFrom(this._client.getTerminology(publicPortalSiteId));

        return terms ?? [];
    }

    public async saveTerminology(
        publicPortalSiteId: number,
        terms: TerminologyOverrideDto[]
    ): Promise<TerminologyConfigDto[]> {
        const request = new SaveTerminologyRequestDto({ terms });

        const saved = await firstValueFrom(
            this._client.saveTerminology(publicPortalSiteId, request)
        );

        this._rum.recordEvent(RumEvent.adminConfigSaved, { section: 'terminology' });

        return saved ?? [];
    }
}
